const $ = jQuery.noConflict();

import AccordionEvents from './accordionEvents';

'use strict';
const EventsList = {
	/**
	 * @description Cache dom and strings
	 * @param {jQuery} $selectEvent
	 * @param {jQuery} $eventsContainer
	 * @param {jQuery} $loader
	 * @param {jQuery} $messageHolder
	 * @param {string|null} filter
	 * @param {array} eventsInfo
	 * @param {boolean} firstAjax
	 * @param {array} icons
	 * @param {int} perPage
	 * @param {int} page
	 */
	$selectEvent: $('.js-events-filter'),
	$eventsContainer: $('.js-events-list-acc'),
	$mainContainer: $('.events-list'),
	$loader: $('.js-events-loader'),
	$messageHolder: $('.events-list__text-message-box'),
	firstAjax: true,
	filter: null,
	eventsInfo: [],
	icons: [],
	perPage: 5,
	page: 1,

	/** @description Initialize class */
	init: function() {
		const _this = this;
		$(document).ready(function() {
			if (_this.$eventsContainer.length > 0) {
				_this.addChangeEventToSelect();
			}
		});
	},

	/** @description Tracks changes on time filter and executes ajax requests when changed */
	addChangeEventToSelect: function() {
		const _this = this;
		_this.page = 1;
		_this.filter = this.$selectEvent.find(':selected').val();
		_this.getEventsAjax();

		this.$selectEvent.on('change', function(e) {
			_this.filter = $(e.target).find(':selected').val();
			_this.page = 1;
			_this.getEventsAjax();
		});
	},

	/** @description Executes ajax request to retrieve events for according to currently active time filter */
	getEventsAjax: function() {
		const _this = this;
		$.ajax({
			type: 'POST',
			dataType: 'json',
			url: window.fwsLocalized.ajaxUrl,
			data: {
				action: 'get-events',
				filter: _this.filter,
				page: _this.page,
			},
			beforeSend: function() {
				_this.$loader.addClass('active');
				_this.$eventsContainer.addClass('active');
			},
			success: function(response) {
				if (response.data.events) {
					_this.eventsInfo = response.data.events;
					_this.icons = response.data.icons;
				} else {
					_this.eventsInfo = [];
				}
			},
			complete: function() {
				_this.$loader.removeClass('active');
				_this.$eventsContainer.removeClass('active');
				_this.afterDataUpdate();
			}
		});
	},

	/** @description In charge of creating HTML for each event in list */
	appendHtml: function() {
		let htmlContent = '';
		for (let i = (this.page - 1) * this.perPage; i <= this.page * this.perPage - 1; i++) {
			if (this.eventsInfo[i]) {
				const location = this.getLocationHtml(this.eventsInfo[i]);
				htmlContent +=
				`<div class="events-list__item js-events-list-acc-item">
					<div class="events-list__date ${this.eventsInfo[i].recurring ? 'recurring' : ''}">
						${this.eventsInfo[i].recurring ? '' : `<span class="events-list__date-month">${this.eventsInfo[i].month}</span>`}
						<span class="events-list__date-day ${this.eventsInfo[i].recurring ? 'recurring' : ''}">${this.eventsInfo[i].day}</span>
					</div>
					<div class="events-list__info">
						<div class="events-list__main-info">
							<h3 class="events-list__main-info-title">${this.eventsInfo[i].name}</h3>
							<span class="events-list__main-info-text events-list__main-info-time">
								${this.icons.iconClock}${this.eventsInfo[i].time}
							</span>
							<span class="events-list__main-info-text events-list__main-info-location">
								${location}
							</span>
							<p class="events-list__main-info-link js-events-list-acc-btn">
								Read More
								${this.icons.iconDown}
							</p>
						</div>
						<div class="events-list__details js-events-list-acc-details">
							<div class="events-list__details-content">
								<p>${this.eventsInfo[i].description}</p>
							</div>
							${this.eventsInfo[i].link ? `<a class="btn btn--white events-list__details-btn" href="${this.eventsInfo[i].link}" target="_blank" aria-label="More Info button" rel="noopener noreferrer"><span>More Info</span></a>` : ''}
						</div>
					</div>
				</div>`;
			}
		}

		if (htmlContent) {
			this.$eventsContainer.show();
			this.$messageHolder.removeClass('events-list__text-message-box--active');
		} else {
			this.$eventsContainer.hide();
			this.$messageHolder.addClass('events-list__text-message-box--active');
		}

		this.$eventsContainer.html(htmlContent);
	},

	/**
	 * @description Prepares html link/text for location
	 * @param eventInfo
	 * @returns {*|string}
	 */
	getLocationHtml: function(eventInfo) {
		const {locationName, locationLink} = eventInfo;

		if (locationName && locationLink) {
			return `
				<a href="${locationLink}" target="_blank" rel="noopener">
					${this.icons.iconLocation}
					<span class="events-list__main-info-location-title">${locationName}</span>
				</a>
			`;
		} else if (locationLink) {
			return `
				<a href="${locationLink}" target="_blank" rel="noopener">
					${this.icons.iconLocation}
					<span class="events-list__main-info-location-title">${locationLink}</span>
				</a>
			`;
		} else if (locationName) {
			return `
				<span>
					${this.icons.iconLocation}
					${locationName}
				</span>
			`;
		}

		return '';
	},

	/** @description Creates pagination and appends it to events container */
	appendPagination: function() {
		const _this = this;
		let htmlPagination = '';
		const numberOfPages = this.eventsInfo.length > 0 ? Math.ceil(this.eventsInfo.length / 5) : 0;
		if (numberOfPages > 1) {
			htmlPagination += '<div class="events-list__pagination">';
			if (this.page > 1) {
				htmlPagination += '<span class="events-list__pagination-number js-pagination prev">Prev</span>';
			}
			for (let i = 1; i <= numberOfPages; i++) {
				htmlPagination += `<span data-page="${i}" class="js-pagination events-list__pagination-number${i === this.page ? ' current' : ''}">${i}</span>`;
			}
			if (numberOfPages >= this.page + 1) {
				htmlPagination += '<span class="events-list__pagination-number js-pagination next">Next</span>';
			}
			htmlPagination += '</div>';
		}
		this.$eventsContainer.append(htmlPagination);

		$('.js-pagination').on('click', function(e) {
			if (e.target.classList.contains('next')) {
				_this.page++;
			} else if (e.target.classList.contains('prev')) {
				_this.page--;
			} else if(!e.target.classList.contains('current')) {
				_this.page = parseInt($(e.target).data('page'));
			} else {
				e.preventDefault();
			}

			_this.afterDataUpdate();
		});
	},

	/**
	 * @description Actions to execute after data has been updated:
	 * - append html for each event
	 * - init events for accordions
	 * - create pagination
	 * - scroll to top of holder
	 */
	afterDataUpdate: function() {
		this.appendHtml();
		AccordionEvents.initEvents();
		this.appendPagination();
		if (!this.firstAjax) {
			$('html, body').animate({
				scrollTop: this.$mainContainer.offset().top - 30
			}, 350);
		} else {
			this.firstAjax = false;
		}
	},
};

export default EventsList;
